<template>
  <PlantillaHome>
    <div slot="contenido">
      <v-card elevation="10" class="d-flex pa-4">
        <!-- <v-btn elevation="10" color="primary" fab><v-icon dark> mdi-plus </v-icon></v-btn>         -->   
        <classifications-indicators-list/>
      </v-card>
    </div>
  </PlantillaHome>
</template>
<script>
import ClassificationsIndicatorsList from '../../../../components/manteiners/classificationsIndicators/ClassificationsIndicatorsList.vue';
import PlantillaHome from "../../../../templates/PlantillaHome";
export default {
  components: {
    PlantillaHome,
    ClassificationsIndicatorsList,    
  },
  data() {
    return {
      
    };
  },
  methods: {},
};
</script>